<template>
    <div class="report-template">
		<report-info
			:reportData="reportData"
			@onUserInfoRender="checkDomRender()"
		/>

		<report-chart-count :reportData="reportData"/>

		<!-- Emotion Levels -->
		<section class="levels-container">
			<h3 class="container-title">
				Emotion Levels
			</h3>

			<h5 class="container-sub-title">
				Average Emotion Result Data (Hr)
			</h5>
		</section>

		<report-line-chart
			class="line-chart"
			:chartTitle="setChartTitle(key, 'emotion_perhour')"
			:yAxisLabels="emotionLevelArray"
			:xAxisLabels="emotionPerHour.xAxisLabels[key]"
			:dataSet="emotionPerHour.dataSet[key]"
			:key="`${key} - 1`"
			v-for="(item, key) in emotionPerHour.count"
		/>

		<section class="levels-container">
			<h5 class="container-sub-title">
				Average Emotion Result Data (Min)
			</h5>
		</section>

		<report-line-chart
			class="line-chart"
			:chartTitle="setChartTitle(key, 'emotion_perminute')"
			:yAxisLabels="emotionLevelArray"
			:xAxisLabels="emotionPerMinute.xAxisLabels[key]"
			:dataSet="emotionPerMinute.dataSet[key]"
			:key="`${key} - 2`"
			v-for="(item, key) in emotionPerMinute.count"
		/>

		<!-- Stress Levels -->
		<section class="levels-container">
			<h3 class="container-title">
				Stress Levels
			</h3>

			<h5 class="container-sub-title">
				Average Stress Result Data (Hr)
			</h5>
		</section>

		<report-line-chart
			class="line-chart"
			:chartTitle="setChartTitle(key, 'stress_perhour')"
			:yAxisLabels="stressLevelArray"
			:xAxisLabels="stressPerHour.xAxisLabels[key]"
			:dataSet="stressPerHour.dataSet[key]"
			:key="`${key} - 3`"
			v-for="(item, key) in stressPerHour.count"
		/>

		<section class="levels-container">
			<h5 class="container-sub-title">
				Average Stress Result Data (Min)
			</h5>
		</section>

		<report-line-chart
			class="line-chart"
			:chartTitle="setChartTitle(key, 'stress_perminute')"
			:yAxisLabels="stressLevelArray"
			:xAxisLabels="stressPerMinute.xAxisLabels[key]"
			:dataSet="stressPerMinute.dataSet[key]"
			:key="`${key} - 4`"
			v-for="(item, key) in stressPerMinute.count"
		/>
    </div>
</template>

<script>
import moment from 'moment'

import ReportInfo from '@/components/user-profile/ReportInfo.vue'
import ReportChartCount from '@/components/user-profile/ReportChartCount.vue'

import ReportLineChart from '@/components/user-profile/ReportLineChart.vue'

export default {
	props: {
		reportData: {
			required: true
		}
	},

	data () {
		return {
			domRendered: false,
			hasFinallyRendered: false,

			emotionLevelArray: [
				'Anxious', 'Sad', 'Tense', 'Challenged',
				'Confused', 'Unpleasant', 'Calm',
				'Pleasant', 'Zen', 'Happy', 'Excitement'
			],

			stressLevelArray: [
				'Low', 'Mild', 'Normal', 'Severe'
			]
		}
	},

	mounted () {
		this.$nextTick(() => {
			this.checkDomRender('dom')
			this.domRendered = true
		})
	},

	computed: {
		emotionPerHour () {
			return this.setXAxisLabelAndDataSet(
				this.reportData.emotion_perhour
			)
		},

		emotionPerMinute () {
			return this.setXAxisLabelAndDataSet(
				this.reportData.emotion_perminute
			)
		},

		stressPerHour () {
			return this.setXAxisLabelAndDataSet(
				this.reportData.stress_perhour
			)
		},

		stressPerMinute () {
			return this.setXAxisLabelAndDataSet(
				this.reportData.stress_perminute
			)
		}
	},

	methods: {
		/* Set Chart Data Methods */
		setXAxisLabelAndDataSet (arr) {
			return arr.reduce((result, item) => {
				result.xAxisLabels.push(
					item.map(x => {
						return moment(new Date(x.datetime)).format('h:mm a')
					})
				)

				result.dataSet.push(
					item.map(x => {
						return x.value
					})
				)

				result.count++

				return result
			}, { xAxisLabels: [], dataSet: [], count: 0 })
		},

		/* Template Methods */
		setChartTitle (key, type) {
			return moment(new Date(this.reportData[type][key][0].datetime)).format('MMMM DD, YYYY')
		},

		checkDomRender () {
			if (
				this.domRendered &&
				!this.hasFinallyRendered
			) {
				this.hasFinallyRendered = true
				this.$emit('domRendered')
			}
		}
	},

	components: {
		ReportInfo,
		ReportLineChart,
		ReportChartCount
	}
}
</script>

<style lang="scss" scoped>
.report-template {
    width: 790px;
    background: #fff;
}
</style>
